module.exports = __webpack_public_path__ + "static/Hospital-5b75bd1ced712070c0e3c964de48b3b6.jpg";